import React from "react";
import { Box, Textarea } from "@chakra-ui/react";
import { r, s } from "./reportTokens";

/**
 * A field the instructor can correct in place.
 *
 * In view mode it renders nothing of its own - the caller draws the text the
 * way the document wants it. In edit mode it swaps in a textarea carrying the
 * same type as the text it replaces, so turning editing on does not make the
 * page jump.
 */
const EditableText = ({
  value,
  onChange,
  placeholder,
  fontSize = s(11),
  fontWeight = "400",
  minHeight = s(44),
}) => (
  <Box className="report-edit-only" width="100%">
    <Textarea
      value={value || ""}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      rows={1}
      fontSize={fontSize}
      fontWeight={fontWeight}
      lineHeight="1.45"
      color={r.ink}
      bg="#ffffff"
      border={`1px solid ${r.editBorder}`}
      borderRadius={s(6)}
      padding={`${s(6)} ${s(8)}`}
      minHeight={minHeight}
      resize="vertical"
      _focus={{ borderColor: r.editFocus, boxShadow: `0 0 0 1px ${r.editFocus}` }}
      _placeholder={{ color: r.muted }}
    />
  </Box>
);

export default EditableText;
